<ng-container *ngIf="localResourcesBloc.localResourceDetails$ | async as localResource">
  <div class="card-container">
    <header class="detail-view-header">
      <kp-feedback-buttons
        *ngIf="localResource?.status === status.done"
        class="hidden-print"
        [preference]="localResource?.data?.userState.preference"
        [screen]="screen"
        [feedbackTitleInfo]="'local ' + localResource?.data?.id"
        [isLocalResource]="true"
        [card]="localResource?.data"
        (feedbackClicked)="moreOrLess($event, localResource?.data)"
        [color]="(themeService.theme$ | async)?.onBackground"
        (cardUnsaved)="closeModalIfUnsaved()"></kp-feedback-buttons>
    </header>

    <section class="top-section">
      <h3>{{ localResource?.data?.programName }}</h3>
      <p class="provider">by {{ localResource?.data?.providerName }}</p>
    </section>

    <kp-next-steps
      class="section middle-section button-container button-container-mobile next-step-container"
      *ngIf="localResource?.status === status.done; else buttonLoading"
      [card]="localResource?.data"></kp-next-steps>

    <section class="section middle-section button-container next-step-container">
      <h3>Next Steps</h3>
      <kp-next-steps
        *ngIf="localResource?.status === status.done; else buttonLoading"
        [card]="localResource?.data"></kp-next-steps>
    </section>

    <section class="middle-section non-location-section">
      <h4>Eligibility</h4>
      <ng-container *ngIf="localResource?.status === status.done; else detailsLoading">
        <ng-container *ngIf="localResource?.data?.rules; else eligibility">
          <ul>
            <li *ngFor="let rule of localResource?.data?.rules">{{ rule }}</li>
          </ul>
        </ng-container>
      </ng-container>
    </section>

    <section class="middle-section non-location-section">
      <h4>Description</h4>
      <div
        class="description"
        [innerHTML]="localResource?.data?.description"
        *ngIf="localResource?.status === status.done; else detailsLoading"></div>
    </section>

    <section class="middle-section location-section">
      <svg-icon class="svg-icon location-svg hidden-print" src="/assets/icons/location.svg"></svg-icon>
      <h3 class="hidden-print">Nearest Location</h3>
      <ng-container *ngIf="localResource?.status === status.done; else officeLoading">
        <kp-local-resource-location
          [office]="localResource?.data?.offices[0]"
          [websiteUrl]="localResource?.data?.websiteUrl"></kp-local-resource-location>
        <button
          *ngIf="localResource?.data?.offices[1] && !otherLocationsShown"
          class="button button-pill other-locations-button hidden-print"
          (click)="showOtherLocations()">
          See other nearby locations
        </button>

        <ng-container *ngIf="otherLocationsShown || isPrint">
          <kp-local-resource-location
            *ngFor="let office of localResource?.data?.offices | slice : 1"
            [office]="office"></kp-local-resource-location>
        </ng-container>
      </ng-container>

      <p class="update-date" *ngIf="localResource?.status === status.done && localResource?.data?.updateDate">
        <kp-branding-icon class="hidden-screen" [product]="product"></kp-branding-icon>
        Program information last updated {{ localResource?.data?.updateDate }}
      </p>
      <p class="attribution hidden-screen">Powered by findhelp</p>
    </section>
  </div>
  <ng-template #eligibility>
    <ul>
      <li>Follow the next steps to find out if this program has eligibility criteria.</li>
    </ul>
  </ng-template>
  <ng-template #officeLoading>
    <kp-shimmer class="office-shimmer" *ngIf="localResource?.status === status.starting; else errorState"></kp-shimmer>
  </ng-template>
  <ng-template #detailsLoading>
    <kp-shimmer class="details-shimmer" *ngIf="localResource?.status === status.starting; else errorState"></kp-shimmer>
  </ng-template>
  <ng-template #buttonLoading>
    <kp-shimmer class="button-shimmer" *ngIf="localResource?.status === status.starting; else errorState"></kp-shimmer>
  </ng-template>
</ng-container>

<ng-template #errorState>
  <div class="error-container">
    <span class="error-title-container">
      <svg-icon src="/assets/icons/alert-circle.svg"></svg-icon>
      Something went wrong.
    </span>
    <p>
      Please click on the resource again or reach out to
      <a href="mailto:support@kumanu.com" target="_blank">support@kumanu.com</a>
      if the problem persists.
    </p>
  </div>
</ng-template>
